//@flow
export const customPendo = {
    track: (name: string, properties: Object): void => {
        if (pendo && pendo.isReady && pendo.isReady()) {
            pendo.track(name, properties);
        }
    },

    trackDataDateRange: (params: {
        startDate: string,
        endDate: string,
        raw?: string,
        source: string
    }): void => {
        customPendo.track('data_date_range', {
            startDate: params.startDate,
            endDate: params.endDate,
            raw: params.raw,
            source: params.source
        });
    }
};
